// extracted by mini-css-extract-plugin
module.exports = {"ecocredits":"EcoCredits_ecocredits__nGN9p"};